import React from 'react';
import { connect } from '../../../../redux/store';
import { compose, withHandlers, withProps } from 'recompose';
import {
  DefaultHeaderComponent,
  DefaultBodyComponent,
  standardConnectMapper,
  DefaultToggleButton,
} from '../ActivityNode';
import { ActivityLogs } from './ActivityLogs';
import { Card, C, openModalForm } from '@kineticdata/bundle-common';
import {
  selectActivityDetailsFromState,
  selectActivityLogsFromState,
  actions,
} from '../../../../redux/modules/submission';
import classNames from 'classnames';

export const ChangeNode = compose(
  connect(
    (state, props) => ({
      ...standardConnectMapper({
        state,
        props,
        dataListExcludes: [
          'Status',
          'Link',
          'InternalLink',
          'DownloadInternalLink',
          'Reference Id',
        ],
      }),
      ...selectActivityDetailsFromState(props.data['Change Number'], state),
      ...selectActivityLogsFromState(props.data['Change Number'], state),
    }),
    { fetchActivityLogs: actions.fetchActivityLogsRequest },
  ),
  withProps(({ activityDetails }) => ({
    canComment:
      activityDetails &&
      activityDetails['Status'] &&
      !['Closed', 'Cancelled'].includes(activityDetails['Status']),
  })),
  withHandlers({
    handleAddComment: props => e => {
      if (props.canComment) {
        openModalForm({
          ...C.COMMENT_FORM_CONFIG,
          kappSlug: props.servicesKapp && props.servicesKapp.slug,
          values: {
            [C.FIELD_RELATED_SUBMISSION_ID]: props.submission.id,
            [C.FIELD_RELATED_TICKET_ID]: props.data['Change Number'],
          },
          duration: 5000,
        });
      }
    },
  }),
)(
  ({
    className,
    activity,
    data,
    submission,
    activityDetailsLoading,
    activityDetails,
    canComment,
    handleAddComment,
    activityLogsLoading,
    activityLogsError,
    activityLogs,
    fetchActivityLogs,
    dataList,
    hasDataList,
    link,
    isDownload,
    approval,
    action,
    appLocation,
    location,
    isOpen,
    toggle,
    isMobile,
  }) => {
    const hasBody = dataList.length > 0 || approval || action;
    const additionalDataList = activityDetails
      ? [
          {
            label: 'Summary',
            value: activityDetails['Summary'],
            key: 'Summary',
          },
          {
            label: 'Status Reason',
            value: activityDetails['Status Reason'],
            key: 'Status Reason',
          },
          {
            label: 'Notes',
            value: activityDetails['Notes'],
            key: 'Notes',
            className: 'pre',
          },
        ].filter(d => !!d.value)
      : [];
    return (
      <li className={classNames('activity__row', className)}>
        <div className="card-wrapper">
          <DefaultToggleButton
            isOpen={!hasBody || isOpen}
            toggle={hasBody ? toggle : undefined}
          />
          <Card>
            <DefaultHeaderComponent
              status={
                !activityDetailsLoading
                  ? (activityDetails && activityDetails.Status) || data.Status
                  : null
              }
              title={activity.label}
              link={link}
              isDownload={isDownload}
              meta={[
                data.Initiated && {
                  label: 'Initiated',
                  value: data.Initiated,
                  timeAgo: true,
                },
                !data.Initiated && {
                  label: 'Created',
                  value: activity.createdAt,
                  timeAgo: true,
                },
              ].filter(Boolean)}
              isOpen={!hasBody || isOpen}
              toggle={hasBody ? toggle : undefined}
              isMobile={isMobile}
            />
            {hasBody && (
              <DefaultBodyComponent
                dataList={[...dataList, ...additionalDataList]}
                approval={approval}
                action={action}
                isOpen={isOpen}
                toggle={toggle}
                appLocation={appLocation}
                location={location}
              >
                <ActivityLogs
                  type="Change"
                  id={data['Change Number']}
                  logs={activityLogs}
                  error={activityLogsError}
                  loading={activityLogsLoading}
                  fetch={fetchActivityLogs}
                  addComment={canComment ? handleAddComment : null}
                />
              </DefaultBodyComponent>
            )}
          </Card>
        </div>
      </li>
    );
  },
);
